import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import BottomNav from "@/components/BottomNav";
import InstallPrompt from "@/components/InstallPrompt";
import LandingPage from "@/pages/LandingPage";
import AuthPage from "@/pages/AuthPage";
import ScanPage from "@/pages/ScanPage";
import DiscoverPage from "@/pages/DiscoverPage";
import MysteryPage from "@/pages/MysteryPage";
import HistoryPage from "@/pages/HistoryPage";
import ProfilePage from "@/pages/ProfilePage";
import CoinShopPage from "@/pages/CoinShopPage";
import AdminPage from "@/pages/AdminPage";
import CollectionDetailPage from "@/pages/CollectionDetailPage";
import { PaymentSuccessPage, PaymentCancelPage } from "@/pages/PaymentPages";
import "@/index.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500 font-mono-data">Loading…</div>;
  if (!user) return <Navigate to="/auth" state={{ from: loc }} replace />;
  return children;
}

function AppShell() {
  const loc = useLocation();
  const noNav = ["/", "/auth", "/payment/success", "/payment/cancel"].includes(loc.pathname);
  return (
    <>
      <InstallPrompt />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/scan" element={<Protected><ScanPage /></Protected>} />
        <Route path="/discover" element={<Protected><DiscoverPage /></Protected>} />
        <Route path="/mystery" element={<Protected><MysteryPage /></Protected>} />
        <Route path="/history" element={<Protected><HistoryPage /></Protected>} />
        <Route path="/saved" element={<Protected><HistoryPage favoritesOnly /></Protected>} />
        <Route path="/profile" element={<Protected><ProfilePage /></Protected>} />
        <Route path="/coins" element={<Protected><CoinShopPage /></Protected>} />
        <Route path="/collections/:id" element={<Protected><CollectionDetailPage /></Protected>} />
        <Route path="/admin" element={<Protected><AdminPage /></Protected>} />
        <Route path="/payment/success" element={<PaymentSuccessPage />} />
        <Route path="/payment/cancel" element={<PaymentCancelPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {!noNav && <BottomNav />}
    </>
  );
}

export default function App() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", () => {
        navigator.serviceWorker.register("/sw.js").catch(() => null);
      });
    }
  }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppShell />
        <Toaster theme="dark" position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
